import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../../Input/Button/Button';

import './EmployerPageJobCallToAction.scss';

export default class EmployerPageJobCallToAction extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        title: PropTypes.string.isRequired,
        description: PropTypes.string,
        jobCount: PropTypes.number.isRequired,
        button: PropTypes.shape({
            text: PropTypes.string,
            url: PropTypes.string,
        }),
    };

    static defaultProps = {};

    render() {
        return (
            <div className="component-CompanyPages-Sections-EmployerPageJobCallToAction">
                <div className="call-to-action-title">{this.props.title}</div>
                <div className="call-to-action-content">
                    {this.props.description && (
                        <div className="call-to-action-description">
                            "{this.props.description}"
                        </div>
                    )}
                    <div className="job-count-display">
                        {this.props.jobCount}
                    </div>
                    <div className="job-count-description">
                        Active Job Listings
                    </div>
                    <div className="call-to-action-button-div">
                        <a
                            className="call-to-action-link"
                            href={this.props.button.url}
                        >
                            <Button
                                type={'solid'}
                                value={this.props.button.text}
                            />
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}
